import React, { useEffect, useRef, useState } from "react";
import "../mycartcomponent/Mycart.css";
import { ApiCall, Web_url } from "../../common/Const";
import store from "../../redux/Store";
import $ from 'jquery';

function WalletPayConfirmModel({res,amt}) {
  const [activeValue, setActiveValue] = useState({});
    const yes =() =>{
      res(amt)
    }
    const no =() =>{
      $("#close_btn").click();
    }
  return (
    <div>
      <div
        class="modal fade"
        id="wllaetPay"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div
              class="modal-body mdl-body"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
            <button
              type="button"
              class="btn-close cbutton"
              id="close_btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{position: "absolute",right: "10px"}}
            ></button>
              <div class="mobile-popup">
                <div class="col-12 textpopup">
                  <h2>Wallet Insufficient Amount!</h2>
                  <p class="paratextpopup" style={{    width: "80%",textAlign: "center",left: "10%",position: "relative"}}>
                      You have insufficient wallet amount, remaining ${parseFloat(amt).toFixed(2)} will be debited from the card
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <button
                class="btn static_remove_button btn-outline-secondary w-50"
                variant="secondary"
                onClick={yes}
              >
                Yes
              </button>
              <button
                class="btn static_wishlist_button btn-outline-primary w-50"
                variant="secondary"
                onClick={no}
              >
                {" "}
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletPayConfirmModel;